/**
 * Main application entry point.
 */

'use strict';


/* eslint vars-on-top: 0 */
var app  = require('mag-app'),
    keys = require('stb-keys');


if ( TARGET === 'android-stb' || TARGET === 'android-app' ) {
    window.removeEventListener('keydown', require('spa-app/lib/events').keydown);
    require('../../../helpers/longpress')(app, {code: keys.ok, emitCode: keys.menu});
}


// everything is ready
app.once('load', function () {
    require('spa-gettext').load({name: core.environment.language}, function () {
        // load pages
        app.pages = {
            main: require('./pages/main')
        };

        // current active panel set
        app.activePanelSet = null;

        core.plugins.settings.init(require('./modules/application.api'), function ( error, data ) {
            if ( error ) {
                app.route(app.pages.main, []);
            } else {
                app.route(app.pages.main, data);
            }

            app.ready();

            core.once('exit', function () {
                var actions = require('./modules/application.api').actions;

                if ( actions.saveSettings ) {
                    actions.saveSettings();
                }
            });
        });
    });
});
